"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Wrapper = exports.UtilityNavLink = exports.UtilityNav = exports.UtilityContainer = exports.Copyright = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Layout = require("../../../../Layout");

var _Link = _interopRequireDefault(require("../../../../Link"));

var _Typography = require("../../../../Typography");

var Copyright = (0, _styled.default)(_Typography.Body)(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      mediaQueries = _ref$theme.mediaQueries,
      menuFooter = _ref$theme.menuFooter,
      space = _ref$theme.space;
  return _defineProperty({
    color: colors[menuFooter.textColor.copyright],
    padding: "".concat(space.small, " 0")
  }, mediaQueries.small, {
    padding: 0
  });
});
exports.Copyright = Copyright;
var UtilityContainer = (0, _styled.default)(_Layout.Container)(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      menuFooter = _ref3$theme.menuFooter;
  return {
    background: colors[menuFooter.backgroundColor]
  };
});
exports.UtilityContainer = UtilityContainer;
var UtilityNav = (0, _styled.default)('nav')(function (_ref4) {
  var space = _ref4.theme.space;
  return {
    paddingBottom: space.medium
  };
});
exports.UtilityNav = UtilityNav;
var UtilityNavLink = (0, _styled.default)(_Link.default)(function (_ref5) {
  var _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      space = _ref5$theme.space;
  return {
    fontSize: '1.4rem',
    marginRight: space.large,
    'span': {
      borderBottomColor: 'transparent',
      color: colors.black
    },
    '&:hover > span': {
      borderBottomColor: colors.black
    }
  };
});
exports.UtilityNavLink = UtilityNavLink;
var Wrapper = (0, _styled.default)('div')(function (_ref6) {
  var _ref6$theme = _ref6.theme,
      colors = _ref6$theme.colors,
      mediaQueries = _ref6$theme.mediaQueries,
      menuFooter = _ref6$theme.menuFooter,
      space = _ref6$theme.space;
  return _defineProperty({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    borderTop: menuFooter.borderStyle,
    borderColor: colors[menuFooter.borderColor],
    padding: "".concat(space.xxlarge, " 0")
  }, mediaQueries.large, {
    flexDirection: 'row'
  });
});
exports.Wrapper = Wrapper;
var _default = UtilityContainer;
exports.default = _default;